/* Display adapter only. Never changes app/cart data or intercepts commerce requests. */
(() => {
  if (window.haroVideoCartBranding) return;
  window.haroVideoCartBranding = true;
  const config = document.getElementById('HaroVideoCartProducts');
  const products = config ? JSON.parse(config.textContent) : [];
  const drawers = new WeakSet();
  const setLabel = (button, label) => {
    if (button && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
  };
  function update(drawer) {
    setLabel(drawer.querySelector('.drv-inside-modal-close-button'), 'Close video cart');
    drawer.querySelectorAll('.drv-line-clamp-2').forEach(title => {
      const product = products.find(item => item.title && item.title === title.textContent.trim());
      const card = title.closest('.drv-shadow-sm');
      if (!card) return;
      card.classList.add('haro-video-cart-item');
      if (product) {
        // Keep React's text node in place so subsequent app renders can update it.
        if (title.firstChild?.nodeType === Node.TEXT_NODE) title.firstChild.data = product.name;
        let detail = title.parentElement.querySelector('.haro-video-cart-detail');
        if (!detail) {
          detail = document.createElement('div');
          detail.className = 'haro-video-cart-detail';
          title.after(detail);
        }
        detail.textContent = product.detail;

      }
      // Keep the app's original line-item photo: it matches cart and checkout.
      card.querySelector('img')?.parentElement.classList.add('haro-video-cart-image');
      const name = title.textContent.trim();
      card.querySelectorAll('button').forEach(button => {
        if (button.querySelector('.lucide-minus')) setLabel(button, 'Decrease quantity of ' + name);
        if (button.querySelector('.lucide-plus')) setLabel(button, 'Increase quantity of ' + name);
      });
    });
  }
  function inspect(root) {
    if (!(root instanceof Element)) return;
    const buttons = root.matches('.drv-popup-checkout-button') ? [root] : root.querySelectorAll('.drv-popup-checkout-button');
    buttons.forEach(button => {
      const drawer = button.closest('.drv-modal-width');
      if (!drawer || drawers.has(drawer)) return;
      drawers.add(drawer);
      drawer.classList.add('haro-video-cart');
      update(drawer);
      // Observe only this small cart subtree, excluding video progress/style updates.
      new MutationObserver(() => update(drawer)).observe(drawer, { childList: true, subtree: true, characterData: true });
    });
    const cartButtons = root.matches('.drv-popup-cart-button') ? [root] : root.querySelectorAll('.drv-popup-cart-button');
    cartButtons.forEach(button => setLabel(button, 'Open video cart'));
  }
  inspect(document.body);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) inspect(node);
  }).observe(document.body, { childList: true, subtree: true });
})();
